import 'bootstrap/dist/css/bootstrap.min.css';
import { SignedIn, SignedOut, SignInButton, SignUpButton, UserButton } from '@clerk/clerk-react';
import { Navbar as RBNavbar, Nav, Container, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

export function Navbar({ onNavigate }: { onNavigate?: (page: string) => void }) {
  return (
    <RBNavbar bg="dark" variant="dark" expand="lg" className="shadow-sm">
      <Container>
        <RBNavbar.Brand href="#" onClick={() => onNavigate && onNavigate('home')}>TextMeLater</RBNavbar.Brand>
        <RBNavbar.Toggle aria-controls="main-navbar" />
        <RBNavbar.Collapse id="main-navbar">
          <Nav className="me-auto">
            <LinkContainer to="/">
              <Nav.Link>Home</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/schedule">
              <Nav.Link>Schedule</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/pricing">
              <Nav.Link>Pricing</Nav.Link>
            </LinkContainer>
          </Nav>
          <Nav className="ms-auto align-items-center">
            <SignedIn>
              <LinkContainer to="/scheduled">
                <Nav.Link>Scheduled</Nav.Link>
              </LinkContainer>
            </SignedIn>
            <div className="d-flex align-items-center ms-3">
              <SignedOut>
                <SignInButton mode="modal">
                  <Button variant="outline-light" className="me-2">Sign In</Button>
                </SignInButton>
                <SignUpButton mode="modal">
                  <Button variant="primary">Sign Up</Button>
                </SignUpButton>
              </SignedOut>
              <SignedIn>
                <UserButton afterSignOutUrl="/" />
              </SignedIn>
            </div>
          </Nav>
        </RBNavbar.Collapse>
      </Container>
    </RBNavbar>
  );
}
